import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';
import findAndAssertColumn from 'data-frames/util/findAndAssertColumn';
import {leafTypeHasBenchlingTypeValueInput} from 'data-types/components/BenchlingTypeValueInputUtil';
import isValidBenchlingTypeValue from 'data-types/util/isValidBenchlingTypeValue';

import {DataFrameFilter, DataFrameFilterOperation} from '../DataFrameFilterTypes';
import {convertToInternalFilterInterface} from './convertFilterInterface';
import getTypeDefForFilterValue from './getTypeDefForFilterValue';

/** Return whether the filter values match the corresponding operators and column types. */
export default function isFilterValid(filter: DataFrameFilter, columns: Array<DataFrameColumnDef>): boolean {
  return filter.filters.every((condition) => {
    const column = findAndAssertColumn({columns}, condition.columnSystemName);
    return (
      !leafTypeHasBenchlingTypeValueInput(column.type.leafType) ||
      condition.operation === DataFrameFilterOperation.IS_NULL ||
      isValidBenchlingTypeValue(
        condition.value,
        getTypeDefForFilterValue(convertToInternalFilterInterface(condition), column)
      )
    );
  });
}
